<template>
  <div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase">
                <strong>Ingresar nueva contraseña</strong>
              </h4>
              <a-form class="login-form" :form="form" @submit="handleSubmit">
                <a-form-item label="Nueva Contraseña">
                  <a-input
                    placeholder="Password1"
                    type="password"
                    v-decorator="[
                      'password1',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Por favor ingresa la nueva contraseña'
                          }
                        ]
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0,0,0,.25);"
                    />
                  </a-input>
                </a-form-item>
                <a-form-item label="Repetir Nueva Contraseña">
                  <a-input
                    placeholder="Password2"
                    type="password"
                    v-decorator="[
                      'password2',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Por favor repite la contraseña'
                          }
                        ]
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0,0,0,.25);"
                    />
                  </a-input>
                </a-form-item>
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button width-160"
                    >Restaurar Contraseña</a-button
                  >
                  <!--
                  <span class="ml-3 register-link">
                    <a
                      href="javascript: void(0);"
                      class="text-primary utils__link--underlined mr-1"
                      >Registrate</a
                    >
                    si todavía no tienes una cuenta
                  </span>
                  -->
                </div>
                <!--
                <div class="form-group">
                  <p>Ingresa desde otra cuenta</p>
                  <div class="mt-2">
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-facebook" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-google" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-windows" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-twitter" />
                    </a>
                  </div>
                </div>
                -->
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start();
          this.$auth
            .newPassword(
              values.password1,
              values.password2,
              this.$route.params.token
            )
            .then(payload => {
              this.$nprogress.done();
              this.$notification["success"]({
                message: "Contraseña Restablecida.",
                description:
                  "Ingresa las nuevas credenciales para ingresar al portal."
              });
              this.$router.replace("/");
            })
            .catch(error => {
              this.$nprogress.done();
              let message = {
                message: "Error de Actualización",
                description:
                  "Hubo un error al actualizar la contraseña. Por favor intente de nuevo."
              };
              if (error.code == "401") {
                message = {
                  message: "El token fue expirado.",
                  description:
                    "Por favor, volver a solicitar el cambio de contraseña."
                };
              }
              this.$notification["warning"](message);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
